import { Form } from 'antd';
import type { FormInstance } from 'antd/lib/form/hooks/useForm';
import { useEffect } from 'react';

type CampaignYearNameSyncProps = {
  /** Injected by GenericForm for Ant Design v4 (no Form.useFormInstance). */
  form: FormInstance;
};

/** Mirror of backend `CAMPAIGN_NAME_PATTERN`: tight brackets, optional second year, required title after `]`. */
const BRACKET_YEAR = /^\[(\d{4})(?:\s*-\s*\d{4})?\]\s+.+/;

function YearFromNameEffect({ form }: { form: FormInstance }) {
  const name = String(form.getFieldValue('name') ?? '');
  const parsed = name.match(BRACKET_YEAR)?.[1] ?? '';
  useEffect(() => {
    if (!parsed) return;
    const current = String(form.getFieldValue('year') ?? '');
    if (parsed !== current) {
      form.setFieldsValue({ year: parsed });
    }
  }, [parsed, form]);
  return null;
}

/**
 * Side-effect-only field: keeps `year` synced to the first bracket year of `name`.
 * The operator only edits the name; the anchor year follows automatically and
 * stays consistent with the backend invariant (Y1 of name = year).
 */
export function CampaignYearNameSync({ form }: CampaignYearNameSyncProps) {
  return (
    <Form.Item shouldUpdate={(prev, cur) => prev?.name !== cur?.name} noStyle>
      {() => <YearFromNameEffect form={form} />}
    </Form.Item>
  );
}
